import { PageBackdrop } from "../components/PageBackdrop";
import { AccentHeading } from "../components/AccentHeading";
import { siteImageUrl } from "../components/SiteImageSetting";
import { useSettings } from "../context/SettingsContext";

export const ABOUT_IMG = "https://images.unsplash.com/photo-1633681926022-84c23e8cb2d6?auto=format&fit=crop&w=1200&q=80";

export default function AboutPage() {
    const { settings } = useSettings();
    const paragraphs = (settings.aboutpage_body || "").split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
    return (
        <div className="relative isolate min-h-screen pt-32 pb-32 grain" data-testid="about-page">
            <PageBackdrop testid="about-bg" />
            <div className="max-w-5xl mx-auto px-6 lg:px-12">
                {settings.aboutpage_overline && <div className="text-overline" data-testid="aboutpage-overline">{settings.aboutpage_overline}</div>}
                <h1 className="font-serif-display text-5xl sm:text-7xl text-[#3D0C1F] mt-3 leading-[0.95] max-w-3xl" data-testid="aboutpage-heading">
                    <AccentHeading text={settings.aboutpage_heading || ""} accent={settings.aboutpage_heading_accent || ""} />
                </h1>
                <img src={siteImageUrl(settings.about_page_image_path, ABOUT_IMG)} alt="Inside The Tresses salon" decoding="async" className="w-full aspect-[16/9] object-cover mt-12" data-testid="aboutpage-image" />
                <div className="mt-12 text-[#7A5262] text-lg leading-loose space-y-6" data-testid="aboutpage-body">
                    {paragraphs.map((p, i) => <p key={i} className="whitespace-pre-line">{p}</p>)}
                    {settings.aboutpage_closing && <p className="font-serif-display text-2xl text-[#3D0C1F] italic" data-testid="aboutpage-closing">{settings.aboutpage_closing}</p>}
                </div>
            </div>
        </div>
    );
}
